import { TransformInt } from '../../../decorators/transform-int.decorator';
import { FileDto } from '../../files/dtos/file.dto';

/**
 * Create vehicle make DTO
 */
export class CreateVehicleModelDto {
	color?: string;
	uuid!: string;
	name!: string;
	notes?: string;
	externalReference?: string;
	@TransformInt()
	makeId!: number;
	files?: FileDto[];
}
